import { backgroundColor } from "@/utils/theme";
import { TableCell, type TableCellProps, type Theme } from "@mui/material";
import type { ReactNode } from "react";

export const EditableCell = ({
	isEditing,
	editor,
	children,
	...cell
}: TableCellProps & {
	isEditing: boolean;
	editor: ReactNode;
	"data-test-id"?: string;
}) => <TableCell {...cell}>{isEditing ? editor : children}</TableCell>;

export const focusedCellSx = (theme: Theme) => ({
	"& td:not(:last-child):focus-within": {
		outline: `2px solid ${theme.palette.primary.main}`,
		outlineOffset: "-2px",
	},
});

export const editableRowSx =
	({ isEditing, isLocked }: { isEditing: boolean; isLocked: boolean }) =>
	(theme: Theme) => ({
		...(isEditing || isLocked
			? null
			: { "&:hover td": { backgroundColor: backgroundColor } }),
		...(isEditing ? focusedCellSx(theme) : null),
		opacity: isLocked ? 0.5 : 1,
	});
